import React from "react";
import PropTypes from "prop-types";
import { AlertCircle, CheckCircle2, Info, TriangleAlert, X } from "lucide-react";

const variantStyles = {
  success: {
    container: "border-green-200 bg-green-50 text-green-900",
    icon: "text-green-700",
  },
  error: {
    container: "border-red-200 bg-red-50 text-red-900",
    icon: "text-red-700",
  },
  warning: {
    container: "border-amber-200 bg-amber-50 text-amber-900",
    icon: "text-amber-700",
  },
  info: {
    container: "border-sky-200 bg-sky-50 text-sky-900",
    icon: "text-sky-700",
  },
};

const icons = {
  success: CheckCircle2,
  error: AlertCircle,
  warning: TriangleAlert,
  info: Info,
};

const Alert = ({ type = "info", title, message, onClose }) => {
  const variant = variantStyles[type] || variantStyles.info;
  const Icon = icons[type] || icons.info;

  return (
    <section
      role={type === "error" ? "alert" : "status"}
      className={`w-full rounded-xl border p-4 shadow-lg backdrop-blur-sm ${variant.container}`}
    >
      <div className="flex items-start gap-3">
        <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${variant.icon}`} aria-hidden="true" />
        <div className="min-w-0 flex-1 space-y-1">
          {title ? <p className="text-sm font-semibold leading-5">{title}</p> : null}
          <p className="text-sm leading-5">{message}</p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="rounded-md p-1 text-current/70 transition-colors hover:bg-black/5 hover:text-current focus:outline-none focus-visible:ring-2 focus-visible:ring-current/30"
          aria-label="Dismiss notification"
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </section>
  );
};

Alert.propTypes = {
  type: PropTypes.oneOf(["success", "error", "warning", "info"]),
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Alert;
